import { render, staticRenderFns } from "./AppointmentSummary.vue?vue&type=template&id=28c4a33e&scoped=true&lang=pug"
import script from "./AppointmentSummary.vue?vue&type=script&lang=js"
export * from "./AppointmentSummary.vue?vue&type=script&lang=js"
import style0 from "./AppointmentSummary.vue?vue&type=style&index=0&id=28c4a33e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28c4a33e",
  null
  
)

export default component.exports